var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterLevel1MRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 76,
    viewBox: "0 0 105 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0818718 52.1492L0.0639 58.0439C0.0639 58.0439 -0.834694 61.6383 4.10757 62.9862C9.04984 64.3341 4.55687 62.9862 4.55687 62.9862L45.8922 74.6679C45.8922 74.6679 50.3851 76.4651 53.9795 75.5665L54.4288 64.7834L20.7316 45.4636L0.0818718 52.1492Z",
    fill: "#B7AE9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.402 49.4532C103.402 49.5072 103.852 55.7973 103.852 55.7973C103.852 55.7973 104.75 59.3917 102.504 60.7396C102.504 60.7396 61.6178 74.2185 61.1685 74.2185C60.7192 74.2185 56.2262 75.1171 53.9797 75.5664V62.0875L103.402 49.4532Z",
    fill: "#A69F91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23921 48.5501C7.23921 48.5501 -7.46628 52.4725 5.23534 54.4314L45.3486 64.8865C45.3486 64.8865 53.7953 69.092 63.7338 64.2351C64.4032 63.9071 100.504 51.8165 100.504 51.8165C100.504 51.8165 107.859 49.2016 99.1653 46.2632L60.391 33.5211C60.391 33.5211 54.3749 31.5622 48.6913 34.5006L7.2437 48.5501H7.23921Z",
    fill: "#D4C9B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5749 49.3185C18.5749 49.3185 7.36945 52.5714 17.1102 53.9687L47.923 61.7325C47.923 61.7325 54.4333 64.9405 61.9815 61.0047C62.4892 60.7396 89.9682 50.8146 89.9682 50.8146C89.9682 50.8146 95.5619 48.6715 88.8809 46.4609L59.061 36.8864C59.061 36.8864 54.4333 35.4127 50.12 37.794L18.5749 49.323V49.3185Z",
    fill: "#C8BEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0056 54.072C41.79 51.7402 43.6276 32.1554 44.4857 21.0263C44.4857 21.0263 35.4459 24.1579 34.5428 23.9647C33.9857 23.8613 31.829 12.557 32.0537 12.2874C33.3971 10.9575 50.1019 5.45814 51.8138 4.99536C53.3459 5.2245 58.8992 6.46007 59.8337 7.35867C59.8337 7.35867 57.2413 52.0727 56.6572 54.8538C56.0147 55.0291 42.4549 54.8044 42.0056 54.0765V54.072Z",
    fill: "#C8BEAE",
    stroke: "#C8BEAE",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0056 54.072C41.79 51.7402 43.6276 32.1554 44.4857 21.0263C44.4857 21.0263 35.4459 24.1579 34.5428 23.9647C33.9857 23.8613 31.829 12.557 32.0537 12.2874C33.3971 10.9575 50.1019 5.45814 51.8138 4.99536C53.3459 5.2245 58.8992 6.46007 59.8337 7.35867C59.8337 7.35867 57.2413 52.0727 56.6572 54.8538C56.0147 55.0291 42.4549 54.8044 42.0056 54.0765V54.072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterLevel1MRDefault);
export default __webpack_public_path__ + "static/media/winter_level_1_m_r_default.e5eb887e7c4089ab7035e7a51a545a37.svg";
export { ForwardRef as ReactComponent };